export default __webpack_public_path__ + "f6e328c1e0e3d5724e6759b9c81bffe4.png";